<template>
  <div class="add-adverts">
    <el-dialog
      :title="adverts.id ? $t('adverts.AddAdverts.649483-0') : $t('adverts.AddAdverts.649483-1')"
      :visible.sync="dialogAdverts"
      width="700px"
      top="9vh"
      @closed="closeDialog"
      @open="openDialog"
      :close-on-click-modal="false"
    >
      <div v-loading="loadingForm" :element-loading-text="$t('adverts.AddAdverts.649483-2')">
        <el-form ref="advertForm" :model="adverts" :rules="formRules">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('adverts.AddAdverts.649483-3')" prop="head">
                <el-input v-model="adverts.head" :placeholder="$t('adverts.AddAdverts.649483-4')" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('adverts.AddAdverts.649483-5')" prop="type">
                <el-select
                  v-model="adverts.type"
                  :placeholder="$t('adverts.AddAdverts.649483-6')"
                  :disabled="!!adverts.id"
                  style="width: 100%"
                >
                  <el-option :label="$t('adverts.AddAdverts.649483-7')" :value="0" />
                  <el-option :label="$t('adverts.AddAdverts.649483-8')" :value="1" />
                  <el-option :label="$t('adverts.AddAdverts.649483-10')" :value="2" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24" v-if="adverts.type === 0">
              <el-form-item :label="$t('adverts.AddAdverts.649483-11')" prop="url">
                <CustomUploadImg
                  :action="uploadUrl"
                  :headers="headers"
                  :limit="1"
                  accept=".jpg,.jpeg,.png"
                  :isType="true"
                  typeKey="type"
                  :imageTypeValue="0"
                  :videoTypeValue="1"
                  :maxSizeMB="3"
                  :previewFromResponse="true"
                  :url.sync="adverts.url"
                  @success="handleImageSuccess"
                  @error="handleUploadError"
                />
                <div class="upload-tips">
                  <p>{{ $t("adverts.AddAdverts.649483-12") }}</p>
                  <p>{{ $t("adverts.AddAdverts.649483-13") }}</p>
                  <p>{{ $t("adverts.AddAdverts.649483-14") }}</p>
                </div>
              </el-form-item>
            </el-col>

            <el-col :span="24" v-if="adverts.type === 1">
              <el-form-item :label="$t('adverts.AddAdverts.649483-11')" prop="url">
                <CustomUploadImg
                  ref="videoUpload"
                  :action="uploadUrl"
                  :headers="headers"
                  :limit="1"
                  accept=".mp4"
                  :isType="true"
                  typeKey="type"
                  :imageTypeValue="0"
                  :videoTypeValue="1"
                  :maxSizeMB="100"
                  :previewFromResponse="true"
                  :data="getVideoUploadData"
                  :url.sync="adverts.url"
                  @success="handleVideoSuccess"
                  @error="handleUploadError"
                />
                <div class="upload-tips">
                  <p>{{ $t("adverts.AddAdverts.649483-12") }}</p>
                  <p>{{ $t("adverts.AddAdverts.649483-13") }}</p>
                  <p>{{ $t("adverts.AddAdverts.649483-14") }}</p>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="adverts.type === 2">
              <el-form-item :label="$t('adverts.AddAdverts.649483-17')" prop="url">
                <el-input v-model="adverts.url" :placeholder="$t('adverts.AddAdverts.649483-18')" clearable />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('adverts.AddAdverts.649483-19')">
                <el-switch v-model="showExtendInfo" />
              </el-form-item>
            </el-col>
          </el-row>

          <template v-if="showExtendInfo">
            <el-row :gutter="20" v-if="adverts.type === 0 || adverts.type === 1">
              <el-col :span="24">
                <el-form-item :label="$t('adverts.AddAdverts.649483-20')">
                  <el-input
                    v-model="adverts.url"
                    :placeholder="$t('adverts.AddAdverts.649483-21')"
                    @input="handleLinkInput"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('adverts.AddAdverts.649483-24')">
                  <el-input v-model="adverts.advertiser" :placeholder="$t('adverts.AddAdverts.649483-25')" clearable />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('adverts.AddAdverts.649483-26')">
                  <el-input v-model="adverts.price" :placeholder="$t('adverts.AddAdverts.649483-27')" clearable />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('adverts.AddAdverts.649483-28')">
                  <el-input
                    v-model="adverts.notes"
                    type="textarea"
                    :rows="3"
                    :placeholder="$t('adverts.AddAdverts.649483-29')"
                    maxlength="200"
                    show-word-limit
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </template>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">{{ $t("adverts.AddAdverts.649483-30") }}</el-button>
        <el-button type="primary" :loading="loadingForm" @click="handleSubmit">
          {{ $t("adverts.AddAdverts.649483-31") }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import config from "@/http/config";
  import CustomUploadImg from "@/components/CustomUploadImg.vue";

  export default {
    name: "AddAdverts",
    components: {
      CustomUploadImg
    },
    props: {
      adverts: {
        type: Object,
        required: true
      },
      dialogAdverts: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        formRules: {
          head: [{ required: true, message: this.$t("adverts.AddAdverts.649483-4"), trigger: "blur" }],
          type: [{ required: true, message: this.$t("adverts.AddAdverts.649483-6"), trigger: "change" }],
          url: [{ required: true, message: this.$t("adverts.AddAdverts.649483-18"), trigger: "blur" }]
        },
        showExtendInfo: false,
        uploadUrl: config.baseUrl + this.$url.Upload.advert,
        sdUploadUrl: config.baseUrl + this.$url.Upload.sdfile,
        headers: {
          token: this.$cookies.get("token")
        },
        loadingForm: false,
        videoDuration: 0
      };
    },
    methods: {
      openDialog() {
        this.showExtendInfo = false;
        this.videoDuration = 0;
      },

      closeDialog() {
        this.$refs.advertForm && this.$refs.advertForm.clearValidate();
        this.showExtendInfo = false;
        this.videoDuration = 0;
        this.$emit("cancel", false, "", "");
      },

      getVideoUploadData(file) {
        return new Promise(resolve => {
          const url = URL.createObjectURL(file);
          const videoElement = document.createElement("video");

          videoElement.addEventListener("loadedmetadata", () => {
            this.videoDuration = Math.ceil(videoElement.duration);
            this.adverts.duration = this.videoDuration;
            URL.revokeObjectURL(url);
            resolve({ duration: this.videoDuration });
          });

          videoElement.addEventListener("error", () => {
            this.videoDuration = 0;
            this.adverts.duration = 0;
            URL.revokeObjectURL(url);
            resolve({ duration: 0 });
          });

          videoElement.src = url;
        });
      },

      handleImageSuccess() {
        this.$message.success(this.$t("adverts.AddAdverts.649483-32"));
      },

      handleVideoSuccess(response) {
        if (response.data && response.data.thumbnail) {
          this.adverts.thumbnail = response.data.thumbnail;
        }
        this.$message.success(this.$t("adverts.AddAdverts.649483-33"));
      },

      handle3DSuccess() {
        this.$message.success(this.$t("adverts.AddAdverts.649483-34"));
      },

      handleUploadError(error) {
        console.error(this.$t("adverts.AddAdverts.649483-35"), error);
      },

      handleLinkInput() {},

      handleCancel() {
        this.$emit("cancel", false, "", "");
      },

      handleSubmit() {
        this.$refs.advertForm.validate(valid => {
          if (!valid) {
            return false;
          }

          this.cleanupDataByType();
          this.submitData();
        });
      },

      cleanupDataByType() {
        const { type } = this.adverts;

        if (type === 0) {
          this.adverts.duration = 0;
          this.adverts.thumbnail = "";
        } else if (type === 1) {
          // 视频类型保留 duration 和 thumbnail
        }
      },

      submitData() {
        this.loadingForm = true;

        const isEdit = !!this.adverts.id;
        const url = isEdit ? this.$url.Adverts.update : this.$url.Adverts.insert;
        const method = isEdit ? this.$method.put : this.$method.post;

        const data = {
          head: this.adverts.head,
          advertiser: this.adverts.advertiser,
          type: this.adverts.type,
          url: this.adverts.url,
          price: this.adverts.price,
          notes: this.adverts.notes
        };

        if (isEdit) {
          data.id = this.adverts.id;
        }

        this.$api
          .request(url, method, data)
          .then(res => {
            if (res.code === 0) {
              this.$notify({
                title: this.$t("common.tip"),
                message: res.msg,
                type: "success"
              });
              this.$emit("cancel", false, isEdit ? "update" : "save");
            } else {
              this.$message.error(res.msg || this.$t("adverts.AddAdverts.649483-38"));
            }
          })
          .catch(error => {
            console.error(this.$t("adverts.AddAdverts.649483-39"), error);
            this.$message.error(this.$t("adverts.AddAdverts.649483-40"));
          })
          .finally(() => {
            this.loadingForm = false;
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
  .add-adverts {
    .upload-tips {
      margin-top: 10px;
      font-size: 12px;
      color: #909399;
      line-height: 1.8;

      p {
        margin: 0;
        padding: 2px 0;
      }
    }
  }
</style>
